import { ProxyMode } from '../../../interfaces';

export const PROXY_MODES_WITH_ACTIONS_ALLOWED: ProxyMode[] = ['http', 'socks4', 'socks5', 'geolocation'];
export const TRAFFIC_LIMIT = 0;
export const DAYS_TO_ARCHIVE = 30;
export const DAYS_TO_ERASE = 180;
